import React, { createContext, useState } from "react";

const initialState = {
    title: []
};

export const GlobalStore = ({ children }) => {
    const [title, setTitle] = useState([]);
    return (
        <GlobalContext.Provider value={ { title: [title, setTitle] } }>
            { children }
        </GlobalContext.Provider>
    );
};

export const GlobalContext = createContext(initialState);
